export const getIsReducedMotionEnabled = () => {
  const reducedMotionMediaQuery = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  );
  const isEnabled = reducedMotionMediaQuery && reducedMotionMediaQuery.matches;
  return isEnabled;
};
